import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-household-member-modal',
  templateUrl: './add-household-member-modal.component.html',
  styleUrls: ['./add-household-member-modal.component.scss']
})
export class AddHouseholdMemberModalComponent {
  @Output() closeModal = new EventEmitter<void>();
  @Output() inviteUser = new EventEmitter<any>();

  inviteForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this.inviteForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]]
    });
  }

  get firstName() {
    return this.inviteForm.get('firstName');
  }

  onInvite() {
    if (this.inviteForm.valid) {
      this.inviteUser.emit(this.inviteForm.value);
    }
  }
}
